export default "__VITE_ASSET__DmW4xYcK__"